function __$styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

import _isEmpty from 'lodash/lang/isEmpty';
import _defaults from 'lodash/object/defaults';
import '@updater/ui-radio-group';
import angular from 'angular';
import _mapValues from 'lodash/object/mapValues';
import _pick from 'lodash/object/pick';
import _isEqual from 'lodash/lang/isEqual';
import _values from 'lodash/object/values';
import _get from 'lodash/object/get';

var template = "<div class=\"upd-address-label\">\n  {{$ctrl.label}}\n</div>\n\n<div class=\"upd-address-status\">\n  <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\n  {{ $ctrl.status }}\n</div>\n\n<div ng-if=\"$ctrl.isEditing\">\n  <upd-address-form class=\"upd-address-form\" ng-model=\"$ctrl.internalModel\" name=\"{{ $ctrl.name }}\" label=\"{{ $ctrl.label }}\" change=\"$ctrl.onFormChange($value)\" required-fields=\"$ctrl.requiredFields\">\n  </upd-address-form>\n\n  <!--\n    ng-hide used to avoid the error from flashing when the component\n    is added to the DOM when switch from static to form display. Angular\n    will remove it automatically based on value of ng-show.\n\n    u-animate is our standard class for enabling animations within Angular.\n    All animations are disabled by default for performance reasons.\n  -->\n  <div class=\"upd-address-error u-animate ng-hide\" ng-show=\"$ctrl.currentError.message\">\n    <div class=\"upd-address-error-content\">\n      <i class=\"fa fa-warning\" aria-hidden=\"true\"></i>\n\n      <span class=\"upd-address-error-message\" ng-bind-html=\"$ctrl.trustAsHtml($ctrl.currentError.message)\">\n      </span>\n\n      <button type=\"button\" class=\"upd-address-error-button\" ng-click=\"$ctrl.force($ctrl.currentError.error)\" ng-if=\"$ctrl.isForceable($ctrl.currentError.error)\" analytics-on analytics-event=\"Clicked Use Address Anyway\" analytics-properties=\"{\n          'Error': $ctrl.currentError.error,\n          'Error Message': $ctrl.currentError.message\n        }\">\n        Use Anyway\n      </button>\n    </div>\n  </div>\n</div>\n\n<upd-address-static class=\"upd-address-static\" ng-if=\"!$ctrl.isEditing\" address=\"$ctrl.internalModel\" editable=\"$ctrl.editable\" click=\"$ctrl.edit()\">\n</upd-address-static>\n";

var ADDRESS_CLASSIFICATION = {
  RESIDENTIAL: 'residential',
  COMMERCIAL: 'commercial',
  MILITARY: 'military',
  UNKNOWN: 'unknown'
};

var ADDRESS_STATUS = {
  VALID: 'valid',
  INVALID: 'invalid',
  APT_NEEDED: 'apt_needed',
  FORCED: 'forced'
};

var ADDRESS_FIELDS = {
  BASE_STREET: 'base_street',
  STREET: 'street',
  APT: 'apt',
  CITY: 'city',
  STATE: 'state',
  ZIP: 'zip',
  OWNERSHIP: 'ownership'
};

var ADDRESS_ERRORS = {
  INVALID: ADDRESS_STATUS.INVALID,
  APT_NEEDED: ADDRESS_STATUS.APT_NEEDED,
  APT_NOT_FOUND: 'apt_not_found',
  COMMERCIAL_FROM: 'commercial_from',
  COMMERCIAL_TO: 'commercial_to',
  MILITARY: 'military',
  DUPLICATE: 'duplicate',
  REQUIRED: 'required'
};

var REQUIRED_FIELDS = [ADDRESS_FIELDS.BASE_STREET, ADDRESS_FIELDS.CITY, ADDRESS_FIELDS.STATE, ADDRESS_FIELDS.ZIP];

var SMARTYSTREETS_DPV_MATCH_CODES = {
  CONFIRMED: 'Y',
  NOT_CONFIRMED: 'N',
  CONFIRMED_DROPPING_SECONDARY: 'S',
  CONFIRMED_MISSING_SECONDARY: 'D'
};

var MILITARY_STATES = ['AA', 'AE', 'AP'];

var US_STATES = ['AL', 'AK', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

var ALL_STATES = [].concat(MILITARY_STATES, US_STATES).sort();

var isAddressComplete = function (address) {
  return REQUIRED_FIELDS.every(function (field) {
    return !!(address || {})[field];
  });
};

var isAddressForced = function (address) {
  return (address || {}).status === ADDRESS_STATUS.FORCED;
};

__$styleInject("/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n\nupd-address {\n  display: block;\n  border: 0 solid;\n  border-radius: 5px;\n  padding: 20px 20px 10px 20px;\n\n  /* Needed for the negative triangle in .upd-address-new */\n  position: relative;\n}\n\nupd-address .upd-address-status {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    height: 27px;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    border-radius: 4px 4px 0 0;\n    background-color: #aac7d6;\n    color: #ffffff;\n    font-size: 14px;\n    font-weight: 300;\n    padding: 1px;\n    height: 100%;\n  }\n\nupd-address .upd-address-status .fa {\n      margin-right: 5px;\n    }\n\nupd-address .upd-address-label {\n    font-size: 24px;\n    text-transform: uppercase;\n    letter-spacing: 2px;\n    text-align: center;\n    margin-bottom: 20px;\n  }\n\nupd-address .upd-address-form, upd-address .upd-address-static {\n    margin-bottom: 10px;\n  }\n\nupd-address .upd-address-error {\n    background: repeating-linear-gradient(\n      -45deg,\n      #ffffff,\n      #ffffff 3px,\n      #f3fcff 3px,\n      #f3fcff 6px\n    );\n    overflow: hidden;\n    max-height: 150px;\n    -webkit-transition: max-height 0.3s;\n    transition: max-height 0.3s;\n\n    /*\n      Target Safari\n      Safari does not render the repeating-linear-gradient the same as other browsers,\n      so we are setting a white background for now instead.\n    */\n  }\n\n@supports (-webkit-marquee-repetition: infinite) and ((-o-object-fit: fill) or (object-fit: fill)) {\n\n  upd-address .upd-address-error {\n    background: #ffffff;\n  }\n}\n\nupd-address .upd-address-error .upd-address-error-content {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      padding: 10px 15px;\n      opacity: 1;\n      -webkit-transition: opacity 0.1s 0.3s;\n      transition: opacity 0.1s 0.3s;\n}\n\nupd-address .upd-address-error .fa-warning {\n      margin-right: 10px;\n      font-size: 26px;\n      color: #f84e57;\n}\n\nupd-address .upd-address-error .upd-address-error-message {\n      display: inline-block;\n      font-size: 14px;\n      line-height: 1.45;\n      padding-right: 5px;\n}\n\nupd-address .upd-address-error.ng-hide {\n  max-height: 0;\n}\n\nupd-address .upd-address-error.ng-hide .upd-address-error-content {\n        opacity: 0;\n        -webkit-transition: opacity 0.1s;\n        transition: opacity 0.1s;\n}\n\nupd-address .upd-address-error-button {\n    background: #f84e57;\n    border: none;\n    color: white;\n    padding: 3px 35px;\n    margin-left: auto;\n    font-size: 14px;\n    white-space: nowrap;\n}\n\nupd-address.upd-address-from {\n  background-color: #d5e3eb;\n  border-color: #d5e3eb;\n}\n\nupd-address.upd-address-from .upd-address-label {\n      color: #5590ad;\n}\n\nupd-address.upd-address-to {\n  background-color: #5590ad;\n  border-color: #5590ad;\n}\n\nupd-address.upd-address-to .upd-address-label {\n      color: #ffffff;\n}\n\nupd-address {/* Since there's no previous sibling selector, making an assumption here that\n*//* if the from and to addresses are siblings, then they must be adjacent.\n*/\n}\n\nupd-address.upd-address-from:not(:only-of-type) {\n  border-radius: 5px 5px 0 0;\n}\n\n/* If the from and to addresses are adjacent, add a divider between them\n*/\n\nupd-address.upd-address-from + upd-address.upd-address-to {\n    border-radius: 0 0 5px 5px;\n\n    /* Account for negative triangle */\n    margin-top: 15px;\n    padding-top: 10px;\n\n    /* --- Start Negative Triangle --- */\n}\n\nupd-address.upd-address-from + upd-address.upd-address-to:before, upd-address.upd-address-from + upd-address.upd-address-to:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  content: '';\n  display: block;\n  position: absolute;\n  top: -19px;\n  border: 10px solid transparent;\n  border-bottom-color: #5590ad;\n  width: 50%;\n}\n\nupd-address.upd-address-from + upd-address.upd-address-to:before {\n  left: 0;\n  border-left: none;\n}\n\nupd-address.upd-address-from + upd-address.upd-address-to:after {\n  right: 0;\n  border-right: none;\n}\n\nupd-address.upd-address-from + upd-address.upd-address-to {/* --- End Negative Triangle ---\n*/\n}\n\n@media (max-width: 767px) {\n\n  upd-address {\n    font-size: 12px;\n  }\n\n  upd-address .upd-address-label {\n      font-size: 19px;\n  }\n      upd-address .upd-address-error .upd-address-error-content {\n        -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n      }\n\n      upd-address .upd-address-error .fa-warning {\n        font-size: 19px;\n        -webkit-box-flex: 0;\n            -ms-flex: 0 0 auto;\n                flex: 0 0 auto; /* Safari iOS */\n      }\n\n      upd-address .upd-address-error .upd-address-error-message {\n        font-size: 12px;\n        -webkit-box-flex: 1;\n            -ms-flex: 1;\n                flex: 1;\n      }\n\n      upd-address .upd-address-error .upd-address-error-button {\n        width: 100%;\n        margin-top: 5px;\n        font-size: 12px;\n      }\n}\n", {});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _STATUS_TEXT;

var assign = Object.assign,
    keys = Object.keys;

// Order Matters Here! - These should be in order of precedence from top to bottom

var ERROR_MESSAGES = [{
  error: ADDRESS_ERRORS.DUPLICATE,
  message: 'Your new and old addresses must be different'
}, {
  error: ADDRESS_ERRORS.APT_NOT_FOUND,
  message: 'Apartment number is invalid'
}, {
  error: ADDRESS_ERRORS.APT_NEEDED,
  message: 'Address requires an apartment number'
}, { error: ADDRESS_ERRORS.INVALID, message: 'We don\'t recognize this address' }, {
  error: ADDRESS_ERRORS.COMMERCIAL_FROM,
  message: '\n      USPS prohibits mail forwarding from a commercial address.\n      <a target="_blank" href="//updater.zendesk.com/hc/en-us/articles/360001648412-My-address-is-classified-as-commercial-but-it-s-residential-Why-is-that-">\n        Learn more\n      </a>\n    '
}, {
  error: ADDRESS_ERRORS.COMMERCIAL_TO,
  message: '\n      Due to USPS policy, you won\'t be able to forward your mail from this address when you move again.\n      <a target="_blank" href="//updater.zendesk.com/hc/en-us/articles/360001648412-My-address-is-classified-as-commercial-but-it-s-residential-Why-is-that-">\n        Learn more\n      </a>\n    '
}, {
  error: ADDRESS_ERRORS.MILITARY,
  message: '\n      The USPS requires that military address changes be completed in-person at your local post office or on the USPS website.\n      <a target="_blank" rel="noopener" href="https://moversguide.usps.com">\n        Visit USPS website\n      </a>\n    '
}, {
  error: ADDRESS_ERRORS.REQUIRED,
  message: 'You have required fields missing'
}];

var FORCEABLE = [ADDRESS_ERRORS.INVALID, ADDRESS_ERRORS.APT_NEEDED, ADDRESS_ERRORS.APT_NOT_FOUND, ADDRESS_ERRORS.COMMERCIAL_TO];

var STATUS_TEXT = (_STATUS_TEXT = {}, defineProperty(_STATUS_TEXT, ADDRESS_STATUS.VALID, 'Official USPS Address'), defineProperty(_STATUS_TEXT, ADDRESS_STATUS.FORCED, 'Overridden Address'), defineProperty(_STATUS_TEXT, ADDRESS_STATUS.INVALID, 'Unrecognized Address'), defineProperty(_STATUS_TEXT, ADDRESS_STATUS.APT_NEEDED, 'Unrecognized Address'), defineProperty(_STATUS_TEXT, ADDRESS_CLASSIFICATION.COMMERCIAL, 'Commercial Address'), defineProperty(_STATUS_TEXT, ADDRESS_CLASSIFICATION.MILITARY, 'Military Address'), _STATUS_TEXT);

var AddressController = function () {
  AddressController.$inject = ['$timeout', 'updAddressVerifier', '$sce'];

  function AddressController($timeout, updAddressVerifier, $sce) {
    'ngInject';

    classCallCheck(this, AddressController);
    Object.assign(this, {
      $timeout: $timeout,
      _verifier: updAddressVerifier,
      trustAsHtml: $sce.trustAsHtml
    });
  }

  createClass(AddressController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      _defaults(this, {
        internalModel: {},
        model: {},
        editable: true,
        allowStatic: true,
        _editing: _isEmpty(this.model)
      });

      this._onAddressChange(this.model);

      // $timeout needed to ensure $validators are set
      this.$timeout(function () {
        _this._forced = isAddressForced(_this.model) ? forceAllValidatorKeys(_this.modelCtrl.$validators) : {};

        _this._verify();
      });
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(_ref) {
      var model = _ref.model;

      if (model) {
        this.internalModel = assign({}, this.internalModel, model.currentValue);
      }
    }
  }, {
    key: 'edit',
    value: function edit() {
      this._editing = this.editable;
    }
  }, {
    key: 'force',
    value: function force(error) {
      this._forced = assign({}, this._forced, defineProperty({}, error, true));

      // For commercial addresses we don't want to set the status to forced because it's valid.
      // However we need to acknowledge that the user is ok with using a commercial address so we
      // mark the form as forced and the address as valid.
      var status = error !== ADDRESS_ERRORS.COMMERCIAL_TO ? ADDRESS_STATUS.FORCED : ADDRESS_STATUS.VALID;
      this._onAddressChange({ status: status });
    }
  }, {
    key: 'isForceable',
    value: function isForceable(error) {
      return FORCEABLE.includes(error);
    }
  }, {
    key: 'onFormChange',
    value: function onFormChange(fields) {
      // We clear the status, classification and forced validations
      // whenever the user changes the address so that we can
      // revalidate the address.
      this._forced = {};
      this._onAddressChange(fields, {
        status: null,
        classification: null,
        // Ensure that `street` always equals `base_street`.
        // TODO: Remove once base_street is not used anymore.
        street: fields[ADDRESS_FIELDS.BASE_STREET]
      });
      this._verify();
    }
  }, {
    key: '_setAddress',
    value: function _setAddress() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this.internalModel = assign.apply(undefined, [{}, this.internalModel].concat(args));
      this.modelCtrl.$setViewValue(this.internalModel);
    }
  }, {
    key: '_onAddressChange',
    value: function _onAddressChange() {
      this._setAddress.apply(this, arguments);
      this.change({ $value: this.internalModel });
    }
  }, {
    key: '_verify',
    value: function _verify() {
      var _this2 = this;

      var success = function (result) {
        if (result) {
          _this2._onAddressChange(result);
        }
      };

      this._verifier.verify(this.internalModel).then(success);
    }
  }, {
    key: 'status',
    get: function () {
      var _ref2 = this.internalModel || {},
          classification = _ref2.classification,
          status = _ref2.status;

      return status === ADDRESS_STATUS.FORCED ? STATUS_TEXT[ADDRESS_STATUS.FORCED] : STATUS_TEXT[classification] || STATUS_TEXT[status] || STATUS_TEXT[ADDRESS_ERRORS.INVALID];
    }
  }, {
    key: 'currentError',
    get: function () {
      var _this3 = this;

      return ERROR_MESSAGES.find(function (_ref3) {
        var error = _ref3.error;
        return _this3.modelCtrl.$error[error];
      }) || {};
    }
  }, {
    key: 'isEditing',
    get: function () {
      return this._editing || !this.allowStatic;
    }
  }, {
    key: '_forced',
    set: function (value) {
      this.modelCtrl._forced = value;
    },
    get: function () {
      return this.modelCtrl._forced;
    }
  }]);
  return AddressController;
}();

var AddressComponent = {
  template: template,
  controller: AddressController,
  require: {
    modelCtrl: 'ngModel',
    formCtrl: '^^?form'
  },
  bindings: {
    model: '<ngModel',
    name: '@',
    label: '@',
    editable: '<?',
    allowStatic: '<?',
    requiredFields: '<updAddressRequired',
    change: '&'
  }
};

function forceAllValidatorKeys(validators) {
  return keys(validators).reduce(function (ret, key) {
    return assign(ret, defineProperty({}, key, true));
  }, {});
}

var template$1 = "<ng-form name=\"form\" ng-class=\"{ 'upd-address-submitted': $ctrl.isFormSubmitted }\" autocomplete=\"on\">\n  <div class=\"upd-address-form-field-group\">\n    <div class=\"upd-address-form-field street\">\n      <input type=\"text\" name=\"{{ $ctrl.streetName }}\" aria-label=\"{{ $ctrl.label }} Street\" class=\"form-control\" ng-model=\"$ctrl.fields.base_street\" placeholder=\"street address\" ng-required=\"$ctrl.isRequired('base_street')\" ng-change=\"$ctrl.onFieldChange()\" ng-model-options=\"$ctrl.modelOptions\" autocomplete=\"address-line1\">\n    </div>\n\n    <div class=\"upd-address-form-field apt\">\n      <input type=\"text\" name=\"{{ $ctrl.aptName }}\" aria-label=\"{{ $ctrl.label }} Apartment\" class=\"form-control\" placeholder=\"apt\" ng-required=\"$ctrl.isRequired('apt')\" ng-model=\"$ctrl.fields.apt\" ng-change=\"$ctrl.onFieldChange()\" ng-model-options=\"$ctrl.modelOptions\" autocomplete=\"address-line2\" empty-string-to-null>\n    </div>\n  </div>\n\n  <div class=\"upd-address-form-field-group\">\n    <div class=\"upd-address-form-field city\">\n      <input type=\"text\" name=\"{{ $ctrl.cityName }}\" aria-label=\"{{ $ctrl.label }} City\" class=\"form-control\" placeholder=\"city\" ng-model=\"$ctrl.fields.city\" ng-required=\"$ctrl.isRequired('city')\" ng-change=\"$ctrl.onFieldChange()\" ng-model-options=\"$ctrl.modelOptions\" autocomplete=\"address-level2\">\n    </div>\n\n    <div class=\"upd-address-form-field state select-wrapper\">\n      <!--\n        Could not use md-select since it does not\n        support autofill, which is essential for\n        addresses.\n\n        A11y: Chrome does not want to announce this aria-label, but Safari does\n      -->\n      <select type=\"text\" name=\"{{ $ctrl.stateName }}\" aria-label=\"{{ $ctrl.label }} State\" class=\"form-control md-updater-theme\" ng-model=\"$ctrl.fields.state\" ng-options=\"state for state in $ctrl.states\" ng-required=\"$ctrl.isRequired('state')\" ng-change=\"$ctrl.onFieldChange()\" ng-model-options=\"$ctrl.modelOptions\" autocomplete=\"address-level1\">\n        <option value=\"\" selected=\"selected\" disabled=\"disabled\" hidden>\n          state\n        </option>\n      </select>\n    </div>\n\n    <div class=\"upd-address-form-field zip\">\n      <input name=\"{{ $ctrl.zipName }}\" aria-label=\"{{ $ctrl.label }} Zip Code\" type=\"text\" class=\"form-control\" ng-model=\"$ctrl.fields.zip\" placeholder=\"zip\" maxlength=\"5\" ng-required=\"$ctrl.isRequired('zip')\" ng-change=\"$ctrl.onFieldChange()\" ng-model-options=\"$ctrl.modelOptions\" autocomplete=\"postal-code\" zip-code>\n    </div>\n  </div>\n\n  <div class=\"upd-address-form-field-group upd-address-form-ownership\" ng-if=\"$ctrl.isRequired('ownership')\">\n    <div class=\"upd-address-ownership-downward-arrow\"></div>\n\n    <label for=\"$ctrl.ownershipName\" class=\"upd-address-ownership-label\">\n      Will you rent or own?\n    </label>\n\n    <upd-radio-group id=\"{{ $ctrl.ownershipName }}\" name=\"{{ $ctrl.ownershipName }}\" class=\"upd-address-ownership\" ng-model=\"$ctrl.fields.ownership\" upd-change=\"$ctrl.onRadioChange($event)\" required>\n      <upd-radio-option class=\"md-updater-theme\" aria-label=\"{{ $ctrl.label }} Rent\" value=\"rent\" label=\"Rent\">\n      </upd-radio-option>\n\n      <upd-radio-option class=\"md-updater-theme\" aria-label=\"{{ $ctrl.label }} Own\" value=\"own\" label=\"Own\">\n      </upd-radio-option>\n    </upd-radio-group>\n  </div>\n</ng-form>\n";

__$styleInject("/* Breakpoint values taken from our original bootstrap setup:\n  xs: 480px\n  sm: 768px\n  md: 992px\n  lg: 1200px\n*/\n\n/*\n  Used to declare these as variables, but no longer works:\n  https://github.com/MoOx/postcss-cssnext/issues/262;\n*/\n\nupd-address-form {\n  display: block;\n}\n\nupd-address-form ng-form {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n\nupd-address-form .upd-address-form-field-group {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n\nupd-address-form .upd-address-form-field.street {\n  -ms-flex-preferred-size: 80%;\n      flex-basis: 80%;\n  margin-right: 1px;\n  margin-bottom: 1px;\n}\n\nupd-address-form .upd-address-form-field.apt {\n  -ms-flex-preferred-size: 20%;\n      flex-basis: 20%;\n  margin-bottom: 1px;\n}\n\nupd-address-form .upd-address-form-field.city {\n  -ms-flex-preferred-size: 40%;\n      flex-basis: 40%;\n  margin-right: 1px;\n}\n\nupd-address-form .upd-address-form-field.state {\n  -ms-flex-preferred-size: 30%;\n      flex-basis: 30%;\n  margin-right: 1px;\n}\n\nupd-address-form .upd-address-form-field.zip {\n  -ms-flex-preferred-size: 30%;\n      flex-basis: 30%;\n}\n\nupd-address-form .upd-address-form-field {/* TODO: Break out into a `select` component\n*/\n}\n\nupd-address-form .upd-address-form-field .form-control {\n      border: 0;\n}\n\nupd-address-form .upd-address-form-field .form-control:focus {\n  border: 0;\n}\n\nupd-address-form .upd-address-form-field.select-wrapper {\n  position: relative;\n  cursor: pointer;\n  overflow: hidden;\n  vertical-align: middle;\n  font-size: 16px;\n  line-height: 1.8;\n  color: #404041;\n  display: inline-block;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  border-radius: 0;\n  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;\n  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;\n  background-image: url('//d30c45h9cuv4p4.cloudfront.net/select-down.svg');\n  background-repeat: no-repeat;\n  background-position: center right 12px;\n  background-size: 15px 7px;\n  background-color: #ffffff;\n}\n\nupd-address-form .upd-address-form-field.select-wrapper > .form-control {\n        width: 100%;\n        background: transparent;\n        border: 0;\n        border-radius: 0;\n        outline: 0;\n        cursor: pointer;\n        -webkit-appearance: none;\n           -moz-appearance: none;\n                appearance: none;\n        color: #666667;\n\n        /* Used as a hack to style the \"placeholder\" option\n           when no option has been selected. Works for now\n           since the select is required. */\n}\n\nupd-address-form .upd-address-form-field.select-wrapper > .form-control:invalid {\n  color: #bababb;\n}\n\nupd-address-form .upd-address-form-field.select-wrapper > .form-control {/* Hide default arrow on IE 11\n*/\n}\n\nupd-address-form .upd-address-form-field.select-wrapper > .form-control::-ms-expand {\n  display: none;\n}\n\nupd-address-form .upd-address-form-field.select-wrapper > .form-control {/* Remove blue background for IE 11\n*/\n}\n\nupd-address-form .upd-address-form-field.select-wrapper > .form-control:focus::-ms-value {\n  background: transparent;\n  color: #666667;\n}\n\nupd-address-form .upd-address-form-ownership {\n    display: block;\n    color: white;\n    text-align: center;\n    margin-bottom: 10px;\n  }\n\nupd-address-form .upd-address-ownership-label {\n    font-size: 19px;\n    font-weight: 300;\n    color: white;\n    margin: 30px 0 20px 0;\n    /* override global styles */\n    text-transform: none;\n  }\n\nupd-address-form .upd-address-ownership-downward-arrow {\n    position: relative;\n    border: solid 1px #aac7d6;\n    margin-top: 30px\n  }\n\nupd-address-form .upd-address-ownership-downward-arrow:before, upd-address-form .upd-address-ownership-downward-arrow:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  border-left: 9px solid transparent;\n  border-right: 9px solid transparent;\n  margin-left: -9px;\n}\n\nupd-address-form .upd-address-ownership-downward-arrow:before {\n  border-top: 9px solid #aac7d6;\n  top: 1px;\n}\n\nupd-address-form .upd-address-ownership-downward-arrow:after {\n  border-top: 9px solid #5590ad;\n  top: -2px;\n}\n\nupd-address-form .upd-address-ownership {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n  }\n\n/*\n    Error state - show error state when the form as been submitted\n    or when the field is dirty and the field is invalid\n  */\n\nupd-address-form .form-control.ng-dirty.ng-invalid, upd-address-form .upd-address-submitted .form-control.ng-invalid, upd-address-form .upd-address-submitted .ng-invalid {\n    border: 2px solid #f97179;\n  }\n\n@media (max-width: 767px) {\n\n  upd-address-form .upd-address-ownership-label {\n      font-size: 16px;\n  }\n}\n\nupd-radio-group.upd-address-ownership {\n  height: auto;\n  border: none;\n  line-height: 1;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  width: 35%;\n  margin: 0 auto;\n}\n", {});

var MODEL_OPTIONS = {
  updateOn: 'default blur',
  debounce: {
    default: 700,
    blur: 0
  }
};

var buildGetFieldName = function (name) {
  return function (field) {
    return field + '_' + name;
  };
};

var AddressFormController = function () {
  function AddressFormController() {
    classCallCheck(this, AddressFormController);
    this.modelOptions = MODEL_OPTIONS;
    this.states = ALL_STATES;
    this.fields = {};
  }

  createClass(AddressFormController, [{
    key: '$onInit',
    value: function $onInit() {
      _defaults(this, {
        showOwnership: false
      });

      var getFieldName = buildGetFieldName(this.name);
      this.streetName = getFieldName('street');
      this.aptName = getFieldName('apt');
      this.cityName = getFieldName('city');
      this.stateName = getFieldName('state');
      this.zipName = getFieldName('zip');
      this.ownershipName = getFieldName('ownership');
    }
  }, {
    key: '$onChanges',
    value: function $onChanges(changes) {
      var model = changes.model;

      if (model) {
        Object.assign(this.fields, model.currentValue);
      }
    }
  }, {
    key: 'isRequired',
    value: function isRequired(field) {
      return (this.requiredFields || []).includes(field);
    }
  }, {
    key: 'onFieldChange',
    value: function onFieldChange() {
      this.change({ $value: this.fields });
    }
  }, {
    key: 'onRadioChange',
    value: function onRadioChange(e) {
      this.fields.ownership = e.target.value;
      this.change({ $value: this.fields });
    }
  }, {
    key: 'isFormSubmitted',
    get: function () {
      return this.formCtrl.$submitted;
    }
  }]);
  return AddressFormController;
}();

var AddressFormComponent = {
  require: {
    formCtrl: '^^?form',
    modelCtrl: 'ngModel'
  },
  bindings: {
    model: '<ngModel',
    name: '@',
    label: '@',
    change: '&',
    requiredFields: '<?'
  },
  template: template$1,
  controller: AddressFormController
};

var EmptyStringToNullDirective = angular.module('angular-common.u-address.form.empty-string-to-null', []).directive('emptyStringToNull', directive);

// This directive converts an empty string to null.
// This is needed in some cases where an empty input
// being set to an empty string would trigger a unnecessary
// change event.
function directive() {
  return {
    require: 'ngModel',
    link: link
  };

  function link(scope, element, attrs, ctrl) {
    ctrl.$parsers.push(emptyStringToNull);
  }
}

function emptyStringToNull(value) {
  return value === '' ? null : value;
}

var EMAIL_REGEXP = /^[A-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-\"\\]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

function InputEmailValidator() {
  return {
    restrict: 'E',
    require: '?ngModel',
    // Make sure we run after ngModel
    priority: 2,
    link: link
  };

  function link(scope, element, attrs, ctrl) {
    if (ctrl && ctrl.$validators.email) {
      // Pulled from angular core
      // @ref: https://github.com/angular/angular.js/blob/master/src/ng/directive/input.js#L1420
      ctrl.$validators.email = function (modelValue, viewValue) {
        var value = modelValue || viewValue;
        return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
      };
    }
  }
}

/**
 * This validator overrides the default angular <input type="email" /> validation
 * with a custom regex that matches our current validation in the Updater API
 */
var InputEmailValidator$1 = angular.module('angular-common.validators.input-email', []).directive('input', InputEmailValidator);

var ZIP_REGEX = /^[0-9]{5}$/;

function ZipCodeValidator() {
  return {
    require: 'ngModel',
    link: link
  };

  function link(scope, element, attrs, ctrl) {
    ctrl.$validators.zipCode = function ($modelValue, $viewValue) {
      var value = $modelValue || $viewValue;
      return !value || ZIP_REGEX.test(value);
    };
  }
}

var ZipCodeValidator$1 = angular.module('angular-common.validators.zip-code', []).directive('zipCode', ZipCodeValidator);

Change.$inject = ['$parse'];
function Change($parse) {
  'ngInject';

  return {
    restrict: 'A',
    compile: function (element, attr) {
      var fn = $parse(attr.updChange);
      return function (scope, element) {
        element.on('change', function (e) {
          scope.$apply(function () {
            fn(scope, { $event: e });
          });
        });
      };
    }
  };
}

var ChangeModule = angular.module('app.directives.change', []).directive('updChange', Change);

var AddressFormModule = angular.module('angular-common.address.form', [EmptyStringToNullDirective.name, ZipCodeValidator$1.name, ChangeModule.name]).component('updAddressForm', AddressFormComponent);

var template$2 = "<div class=\"upd-address-static-wrapper\" ng-class=\"{ clickable: $ctrl.editable }\" ng-click=\"$ctrl.click()\">\n  <div class=\"upd-address-static-content\">\n    <div>{{$ctrl.address.base_street}} {{$ctrl.address.apt}}</div>\n    <div>{{$ctrl.address.city}}, {{$ctrl.address.state}} {{$ctrl.address.zip | zipCode}}</div>\n  </div>\n\n  <i ng-if=\"$ctrl.editable\" class=\"fa fa-pencil\"></i>\n</div>\n";

__$styleInject("upd-address-static {\n  display: block;\n  text-align: left;\n}\n\n  upd-address-static .upd-address-static-wrapper {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    padding: 6px 12px;\n    background-color: #ffffff\n  }\n\n  upd-address-static .upd-address-static-wrapper.clickable {\n  cursor: point;\n}\n\n  upd-address-static .upd-address-static-wrapper:hover .fa-pencil {\n        opacity: 0.5;\n}\n\n  upd-address-static .fa-pencil {\n    padding: 5px;\n    opacity: 0.3;\n    font-size: 14px;\n  }\n", {});

var AddressStaticComponent = {
  bindings: {
    address: '<',
    editable: '<',
    click: '&'
  },
  template: template$2
};

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

DynamicFilter.$inject = ['$filter'];

/**
 * Allows for dynamically assigning filters in templates.
 * E.g.: in controller: $scope.nameFilter = 'uppercase'
 *       in template:   {{item | dynamicFilter:nameFilter}}
 *
 * Filter arguments (in addition to input) can be passed using
 * ":" as a separator.
 * E.g.: in controller: $scope.nameFilter = 'limitTo:0:20'
 *       in template:   {{item | dynamicFilter:nameFilter}}
 */
function DynamicFilter($filter) {
  'ngInject';

  return function (input, filter) {
    if (angular.isString(filter)) {
      var split = filter.split(':');
      var args = [input].concat(split.slice(1));
      filter = split[0];
      return $filter(filter).apply(null, args);
    } else if (angular.isFunction(filter)) {
      return filter(input);
    } else {
      throw new Error('dynamicFilter: filter must be either an Array or String. Got ' + (typeof filter === 'undefined' ? 'undefined' : _typeof$1(filter)) + '.');
    }
  };
}

var DynamicFilter$1 = angular.module('angular-common.filters.dynamic-filter', []).filter('dynamicFilter', DynamicFilter);

function PhoneNumberFilter() {
  return function (input) {
    var ext = void 0;

    // Assumes the the extension is the only A-Z character in the number
    var split = (input || '').split(/[a-zA-Z]+/);

    // Strip all non-numeric values from the phone number
    var number = split[0].replace(/\D/g, '').trim();

    // Remove the . if it exists
    if (split[1]) {
      ext = split[1].replace(/^\./, '').trim();
    }

    // Remove country code if it exists
    if (number.length === 11) {
      number = number.substr(1);
    }

    // Exit early if the number is empty
    if (!number) {
      return '';
    }

    // Format the phone number
    var areaCode = number.substr(0, 3);
    var exchange = number.substr(3, 3);
    var subscriber = number.substr(6, 4);
    var formatted = '(' + areaCode + ') ' + exchange + '-' + subscriber;

    // Apply the extension if it exists
    if (ext) {
      formatted += ' x' + ext;
    }

    return formatted.trim();
  };
}

var PhoneNumberFilter$1 = angular.module('angular-common.filters.phone-number', []).filter('phoneNumber', PhoneNumberFilter);

/**
 * Returns a property from an object.
 */
function ReduceToPropertyFilter() {
  return function (input, propertyName) {
    return input[propertyName];
  };
}

var ReduceToPropertyFilter$1 = angular.module('angular-common.filters.reduce-to-property', []).filter('reduceToProperty', ReduceToPropertyFilter);

function TitleizeFilter() {
  return function (input) {
    // https://github.com/sindresorhus/titleize
    return (input || '').toLowerCase().replace(/(?:^|\s|-)\S/g, function (s) {
      return s.toUpperCase();
    });
  };
}

var TitleizeFilter$1 = angular.module('angular-common.filters.titleize', []).filter('titleizeFilter', TitleizeFilter);

function ZipCodeFilter() {
  return function (zip) {
    return (zip || '').substring(0, 5);
  };
}

var ZipCodeFilter$1 = angular.module('angular-common.filters.zip-code', []).filter('zipCode', ZipCodeFilter);

var AddressStaticModule = angular.module('angular-common.address.static', [ZipCodeFilter$1.name]).component('updAddressStatic', AddressStaticComponent);

var CONFIRMED_DROPPING_SECONDARY = SMARTYSTREETS_DPV_MATCH_CODES.CONFIRMED_DROPPING_SECONDARY;


var isDpvMatchCode = function (code) {
  return function (address) {
    return getAddressDpvMatchCode(address) === code;
  };
};

var isDpvMatchCodeConfirmedDroppingSecondary = isDpvMatchCode(CONFIRMED_DROPPING_SECONDARY);

var getAddressDpvMatchCode = function (address) {
  return (address.analysis || {}).dpv_match_code;
};

var isErrorForced = function (error) {
  return function (forcedObj) {
    return !!(forcedObj || {})[error];
  };
};

var isPropertyValid = function (property) {
  return function (error) {
    return function (obj) {
      return (obj || {})[property] !== error;
    };
  };
};

var isStatusValid = isPropertyValid('status');
var isClassificationValid = isPropertyValid('classification');

var ERROR = ADDRESS_ERRORS.APT_NEEDED;
var isAptNeededValid = isStatusValid(ERROR);
var isAptNeededForced = isErrorForced(ERROR);

function AddressAptNeededValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return isAptNeededForced(ctrl._forced) || isAptNeededValid(value);
      };
    }
  };
}

var ERROR$1 = ADDRESS_ERRORS.APT_NOT_FOUND;
var isAptNotFoundForced = isErrorForced(ERROR$1);

function AddressAptNotFoundValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR$1] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return isAptNotFoundForced(ctrl._forced) || !isDpvMatchCodeConfirmedDroppingSecondary(value);
      };
    }
  };
}

var ERROR$2 = ADDRESS_ERRORS.COMMERCIAL_FROM;
var CLASSIFICATION = ADDRESS_CLASSIFICATION.COMMERCIAL;
var isCommercialValid = isClassificationValid(CLASSIFICATION);

function AddressCommercialFromValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR$2] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return isCommercialValid(value);
      };
    }
  };
}

var ERROR$3 = ADDRESS_ERRORS.COMMERCIAL_TO;
var CLASSIFICATION$1 = ADDRESS_CLASSIFICATION.COMMERCIAL;
var isCommercialForced = isErrorForced(ERROR$3);
var isCommercialValid$1 = isClassificationValid(CLASSIFICATION$1);

function AddressCommercialToValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR$3] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return isCommercialForced(ctrl._forced) || isCommercialValid$1(value);
      };
    }
  };
}

var ERROR$4 = ADDRESS_ERRORS.MILITARY;
var CLASSIFICATION$2 = ADDRESS_CLASSIFICATION.MILITARY;
var isMilitaryValid = isClassificationValid(CLASSIFICATION$2);

function AddressMilitaryValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ctrl) {
      ctrl.$validators[ERROR$4] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return isMilitaryValid(value);
      };
    }
  };
}

var ERROR$5 = ADDRESS_ERRORS.INVALID;
var isInvalidForced = isErrorForced(ERROR$5);
var isInvalid = isStatusValid(ERROR$5);

function AddressInvalidValidator() {
  return {
    require: ['ngModel', '^^form'],
    restrict: 'A',
    link: function (scope, element, attrs, _ref) {
      var _ref2 = slicedToArray(_ref, 2),
          modelCtrl = _ref2[0],
          formCtrl = _ref2[1];

      if (formCtrl) {
        scope.$watch(function () {
          return formCtrl.$submitted;
        }, function () {
          return modelCtrl.$validate();
        });
      }

      modelCtrl.$validators[ERROR$5] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return isInvalidForced(modelCtrl._forced) || isInvalid(value);
      };
    }
  };
}

var ERROR$6 = ADDRESS_ERRORS.REQUIRED;

function AddressRequiredValidator() {
  return {
    require: ['ngModel', '^^form'],
    restrict: 'A',
    link: function (scope, element, attrs, _ref) {
      var _ref2 = slicedToArray(_ref, 2),
          modelCtrl = _ref2[0],
          formCtrl = _ref2[1];

      var handler = scope.$watch(function () {
        return formCtrl.$submitted;
      }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
          modelCtrl.$validate();
          handler();
        }
      });

      var getRequired = function () {
        return scope.$eval(attrs.updAddressRequired) || [];
      };

      modelCtrl.$validators[ERROR$6] = function (modelValue, viewValue) {
        var value = modelValue || viewValue || {};
        return !formCtrl.$submitted || getRequired().every(function (field) {
          return !!value[field];
        });
      };
    }
  };
}

var toLowerCase = function (value) {
  return value && value.toLowerCase();
};

function AddressDuplicateValidator() {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: link
  };

  function link(scope, element, attrs, ctrl) {
    // Set allowInvalid so angular doesn't set the model to
    // undefined when invalid so we can compare the model values
    ctrl.$overrideModelOptions({
      allowInvalid: true
    });

    var getDependentModelValue = function () {
      return scope.$eval(attrs.updAddressDuplicate);
    };

    scope.$watch(getDependentModelValue, function () {
      return ctrl.$validate();
    });

    ctrl.$validators[ADDRESS_ERRORS.DUPLICATE] = function (modelValue, viewValue) {
      var value = modelValue || viewValue || {};
      var models = [value, getDependentModelValue()];
      return areAllModelsEmpty(models) || !areModelsEqual(models);
    };
  }
}

function areAllModelsEmpty(models) {
  return models.every(function (model) {
    return _isEmpty(getBaseAddressFields(model));
  });
}

function areModelsEqual(_ref) {
  var _ref2 = slicedToArray(_ref, 2),
      model1 = _ref2[0],
      model2 = _ref2[1];

  return _isEqual(getBaseAddressFields(model1), getBaseAddressFields(model2));
}

function getBaseAddressFields(address) {
  var selectFields = [ADDRESS_FIELDS.STREET, ADDRESS_FIELDS.APT, ADDRESS_FIELDS.CITY, ADDRESS_FIELDS.STATE, ADDRESS_FIELDS.ZIP];

  return _mapValues(_pick(address, selectFields), toLowerCase);
}

var AddressValidatorsModule = angular.module('angular-common.address.validators', []).directive('updAddressAptNeeded', AddressAptNeededValidator).directive('updAddressAptNotFound', AddressAptNotFoundValidator).directive('updAddressCommercialFrom', AddressCommercialFromValidator).directive('updAddressCommercialTo', AddressCommercialToValidator).directive('updAddressMilitary', AddressMilitaryValidator).directive('updAddressInvalid', AddressInvalidValidator).directive('updAddressRequired', AddressRequiredValidator).directive('updAddressDuplicate', AddressDuplicateValidator);

var hasBeenVerified = function (_ref) {
  var status = _ref.status,
      classification = _ref.classification;
  return status && classification;
};

var shouldVerify = function (address) {
  return isAddressComplete(address) && !hasBeenVerified(address) && !isAddressForced(address);
};

var AddressVerifierService = function () {
  AddressVerifierService.$inject = ['$q', 'updSmartyStreetsService'];

  function AddressVerifierService($q, updSmartyStreetsService) {
    'ngInject';

    classCallCheck(this, AddressVerifierService);
    this._$q = $q;
    this._service = updSmartyStreetsService;
  }

  createClass(AddressVerifierService, [{
    key: 'verify',
    value: function verify(address) {
      return (shouldVerify(address) ? this._service.request(address) : this._$q.resolve(address)).then(function (result) {
        return _extends({}, result, {
          // While smartystreets provides its own classification of military addresses it doesn't classify invalid addresses
          // as military if they have a military state. We want to classify such addresses as military since they can never
          // be forwarded to.
          classification: MILITARY_STATES.includes(address.state) ? ADDRESS_CLASSIFICATION.MILITARY : result.classification || ADDRESS_CLASSIFICATION.UNKNOWN
        });
      });
    }
  }]);
  return AddressVerifierService;
}();

var _STATUS_MAP;

var STATUS_MAP = (_STATUS_MAP = {}, defineProperty(_STATUS_MAP, SMARTYSTREETS_DPV_MATCH_CODES.CONFIRMED, ADDRESS_STATUS.VALID), defineProperty(_STATUS_MAP, SMARTYSTREETS_DPV_MATCH_CODES.NOT_CONFIRMED, ADDRESS_STATUS.INVALID), defineProperty(_STATUS_MAP, SMARTYSTREETS_DPV_MATCH_CODES.CONFIRMED_DROPPING_SECONDARY, ADDRESS_STATUS.INVALID), defineProperty(_STATUS_MAP, SMARTYSTREETS_DPV_MATCH_CODES.CONFIRMED_MISSING_SECONDARY, ADDRESS_STATUS.APT_NEEDED), _STATUS_MAP);

// Order matters here!
var STREET_COMPONENTS = ['primary_number', 'street_predirection', 'street_name', 'street_suffix', 'street_postdirection'];

function parseSmartyStreetsResponse(response) {
  var analysis = response.analysis || {};
  var components = response.components || {};
  var metadata = response.metadata || {};
  var address = parseAddress(components);
  var statusAndClass = {
    status: parseStatus(analysis, metadata),
    classification: parseClassification(analysis, metadata)
  };
  var smartyStreetsElements = {
    analysis: analysis,
    components: components,
    metadata: metadata
  };

  return _isEmpty(response) ? statusAndClass : Object.assign(address, smartyStreetsElements, statusAndClass);
}

function parseAddress(components) {
  var street = parseStreet(components);

  return {
    // Need to set `street` and `base_street` for now.
    // TODO: Remove once / if we ever get rid of street / base_street concept
    base_street: street,
    street: street,
    apt: _get(components, 'secondary_number', null),
    city: _get(components, 'city_name', null),
    state: _get(components, 'state_abbreviation', null),
    zip: _get(components, 'zipcode', null),
    add_on_zip: _get(components, 'plus4_code', null)
  };
}

function parseClassification(analysis, metadata) {
  if (isMilitary(analysis, metadata)) {
    return ADDRESS_CLASSIFICATION.MILITARY;
  }

  return (metadata.rdi || ADDRESS_CLASSIFICATION.UNKNOWN).toLowerCase();
}

function isMilitary(_ref, _ref2) {
  var _ref$footnotes = _ref.footnotes,
      footnotes = _ref$footnotes === undefined ? '' : _ref$footnotes,
      _ref$dpv_footnotes = _ref.dpv_footnotes,
      dpv_footnotes = _ref$dpv_footnotes === undefined ? '' : _ref$dpv_footnotes;
  var zip_type = _ref2.zip_type;

  // 1. Match made to a record with a military or diplomatic ZIP Code.
  // 2. Matched to military or diplomatic address.
  // 3. The ZIP Code pertains to military units and diplomatic organizations,
  // often in foreign locations.
  return footnotes.includes('Y#') || dpv_footnotes.includes('F1') || zip_type === 'Military';
}

function parseStatus(analysis, metadata) {
  return STATUS_MAP[analysis.dpv_match_code] || ADDRESS_STATUS.INVALID;
}

function parseStreet(components) {
  return _values(_pick(components, STREET_COMPONENTS)).filter(function (property) {
    return !!property;
  }).join(' ');
}

var _TO_SMARTYSTREETS_MAP;

var assign$1 = Object.assign,
    keys$1 = Object.keys;


var TO_SMARTYSTREETS_MAP = (_TO_SMARTYSTREETS_MAP = {}, defineProperty(_TO_SMARTYSTREETS_MAP, ADDRESS_FIELDS.BASE_STREET, 'street'), defineProperty(_TO_SMARTYSTREETS_MAP, ADDRESS_FIELDS.APT, 'secondary'), defineProperty(_TO_SMARTYSTREETS_MAP, ADDRESS_FIELDS.CITY, 'city'), defineProperty(_TO_SMARTYSTREETS_MAP, ADDRESS_FIELDS.STATE, 'state'), defineProperty(_TO_SMARTYSTREETS_MAP, ADDRESS_FIELDS.ZIP, 'zipcode'), _TO_SMARTYSTREETS_MAP);

var SAMPLE_FIELDS_1 = [ADDRESS_FIELDS.BASE_STREET, ADDRESS_FIELDS.APT, ADDRESS_FIELDS.CITY, ADDRESS_FIELDS.STATE];
var SAMPLE_FIELDS_2 = [ADDRESS_FIELDS.BASE_STREET, ADDRESS_FIELDS.APT, ADDRESS_FIELDS.ZIP];

var INVALID_RESPONSE = {
  status: ADDRESS_STATUS.INVALID,
  classification: ADDRESS_CLASSIFICATION.UNKNOWN,
  analysis: null,
  components: null,
  metadata: null
};

var ENDPOINT = 'https://api.smartystreets.com/street-address';

var SmartyStreetsService = function () {
  SmartyStreetsService.$inject = ['$q', '$http', 'updEnvironment', '$sce'];

  function SmartyStreetsService($q, $http, updEnvironment, $sce) {
    'ngInject';

    // `authToken` is the only key that is always required. For testing scenarios (e2e) we
    // may also have the `authId`.

    classCallCheck(this, SmartyStreetsService);
    if (!_get(updEnvironment, 'keys.smartystreets.authToken')) {
      throw new Error('[SmartyStreetsService] updEnvironment does not contain smartystreets `authToken` key');
    }

    assign$1(this, {
      $q: $q,
      $http: $http,
      $sce: $sce,
      keys: updEnvironment.keys.smartystreets
    });
  }

  createClass(SmartyStreetsService, [{
    key: '_buildHttpCalls',
    value: function _buildHttpCalls(addresses) {
      var _this = this;

      return addresses.map(mapToSmartyStreets).map(function (address) {
        return assign$1({}, _this._params, address);
      }).map(function (params) {
        return _this.$http.jsonp(_this.$sce.trustAsResourceUrl(ENDPOINT), { params: params });
      });
    }
  }, {
    key: 'request',
    value: function request(address) {
      // Need to get 2 samples so we can compare the responses from
      // Smartystreets so we know whether to update the address or not
      var addresses = address ? getSamples(address) : [];
      var calls = this._buildHttpCalls(addresses);

      // Would love to do this in a single call using
      // smartystreets POST method, but for client side
      // auth we can't! :-(
      // https://smartystreets.com/docs/cloud/us-street-api#http-request-methods
      return this.$q.all(calls).then(success, error);

      function success() {
        var responses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var results = responses.map(function (response) {
          return response.data[0];
        }).map(function (data) {
          return processResponse(data);
        }).filter(function (response) {
          return keys$1(response).length;
        });

        // Need to compare the two samples results to determine if we
        // have a valid address. If not we don't know the validity
        // of the address, so mark it as invalid and unknown.
        return areResultsEqual(results) ? results[0] : INVALID_RESPONSE;
      }

      function error() {
        return INVALID_RESPONSE;
      }
    }
  }, {
    key: '_params',
    get: function () {
      return {
        'auth-id': this.keys.authId,
        'auth-token': this.keys.authToken,
        jsonpCallbackParam: 'cb'
      };
    }
  }]);
  return SmartyStreetsService;
}();

function getSamples(address) {
  return [_pick(address, SAMPLE_FIELDS_1), _pick(address, SAMPLE_FIELDS_2)];
}

function processResponse(response) {
  return response ? parseSmartyStreetsResponse(response) : {};
}

function mapToSmartyStreets(address) {
  var map = TO_SMARTYSTREETS_MAP;

  return Object.keys(map).reduce(function (result, key) {
    return assign$1(result, defineProperty({}, map[key], address[key]));
  }, {});
}

function areResultsEqual(results) {
  var _results$map = results.map(function (result) {
    return _pick(result, REQUIRED_FIELDS);
  }),
      _results$map2 = slicedToArray(_results$map, 2),
      address1 = _results$map2[0],
      address2 = _results$map2[1];

  return results.length && _isEqual(address1, address2);
}

var SmartyStreetsModule = angular.module('angular-common.address.smartystreets', []).service('updSmartyStreetsService', SmartyStreetsService);

var AddressVerifierServiceModule = angular.module('angular-common.address.verifier', [SmartyStreetsModule.name]).service('updAddressVerifier', AddressVerifierService);

var AddressModule = angular.module('angular-common.address', [AddressFormModule.name, AddressStaticModule.name, AddressValidatorsModule.name, AddressVerifierServiceModule.name]).component('updAddress', AddressComponent);

export { AddressModule };
